var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("chart-card", {
    attrs: {
      title: "Example Pie Card",
      chartData: _vm.chartData,
      height: _vm.$vuetify.breakpoint.smAndDown ? "400px" : undefined
    }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }